import DateRangePicker from '../DateRangePicker'
import './styles.css'

function AIAssistantStep2({ 
  periodStartDate, 
  periodEndDate, 
  onPeriodChange,
  dataToExploit, 
  onDataToExploitChange,
  chartType,
  onChartTypeChange
}) {
  const formatDateForPicker = (dateString) => {
    if (!dateString) return ''
    const date = new Date(dateString)
    if (isNaN(date.getTime())) return dateString
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    return `${day}/${month}/${year}`
  }

  return (
    <div className="ai-assistant-step2">
      <div className="ai-assistant-section">
        <h3 className="ai-assistant-section-title">Seleccionar periodo</h3>
        <DateRangePicker
          startDate={formatDateForPicker(periodStartDate)}
          endDate={formatDateForPicker(periodEndDate)}
          onChange={onPeriodChange}
        />
      </div>

      <div className="ai-assistant-section">
        <h3 className="ai-assistant-section-title">Datos a explotar</h3>
        <div className="ai-assistant-options">
          <label className="ai-radio-card">
            <input
              type="radio"
              name="dataToExploit"
              value="usuarios-activos-vs-no-activos"
              checked={dataToExploit === 'usuarios-activos-vs-no-activos'}
              onChange={(e) => onDataToExploitChange(e.target.value)}
            />
            <span className="ai-radio-label">Usuarios activos vs Usuarios no activos</span>
          </label>
          <label className="ai-radio-card">
            <input
              type="radio"
              name="dataToExploit"
              value="usuarios-mas-autorizaciones"
              checked={dataToExploit === 'usuarios-mas-autorizaciones'}
              onChange={(e) => onDataToExploitChange(e.target.value)}
            />
            <span className="ai-radio-label">Usuarios con más Autorizaciones</span>
          </label>
          <label className="ai-radio-card">
            <input
              type="radio"
              name="dataToExploit"
              value="usuarios-mas-capturas"
              checked={dataToExploit === 'usuarios-mas-capturas'}
              onChange={(e) => onDataToExploitChange(e.target.value)}
            />
            <span className="ai-radio-label">Usuarios con más capturas</span>
          </label>
          <label className="ai-radio-card">
            <input
              type="radio"
              name="dataToExploit"
              value="usuarios-mas-sesiones"
              checked={dataToExploit === 'usuarios-mas-sesiones'}
              onChange={(e) => onDataToExploitChange(e.target.value)}
            />
            <span className="ai-radio-label">Usuarios con más sessiones iniciadas</span>
          </label>
          <label className="ai-radio-card">
            <input
              type="radio"
              name="dataToExploit"
              value="usuarios-vs-capturas"
              checked={dataToExploit === 'usuarios-vs-capturas'}
              onChange={(e) => onDataToExploitChange(e.target.value)}
            />
            <span className="ai-radio-label">Usuarios vs Capturas</span>
          </label>
          <label className="ai-radio-card">
            <input
              type="radio"
              name="dataToExploit"
              value="usuarios-vs-precintos"
              checked={dataToExploit === 'usuarios-vs-precintos'}
              onChange={(e) => onDataToExploitChange(e.target.value)}
            />
            <span className="ai-radio-label">Usuarios vs Precintos</span>
          </label>
        </div>
      </div>

      <div className="ai-assistant-section">
        <h3 className="ai-assistant-section-title">Tipo de Gráfico</h3>
        <div className="ai-chart-type-options">
          <label className="radio-option">
            <input
              type="radio"
              name="chartType"
              value="lineal"
              checked={chartType === 'lineal'}
              onChange={(e) => onChartTypeChange(e.target.value)}
            />
            <span className="radio-label">Lineal</span>
          </label>
          <label className="radio-option">
            <input
              type="radio"
              name="chartType"
              value="barras"
              checked={chartType === 'barras'}
              onChange={(e) => onChartTypeChange(e.target.value)}
            />
            <span className="radio-label">Barras</span>
          </label>
          <label className="radio-option">
            <input
              type="radio"
              name="chartType"
              value="circular"
              checked={chartType === 'circular'}
              onChange={(e) => onChartTypeChange(e.target.value)}
            />
            <span className="radio-label">Circular</span>
          </label>
        </div>
      </div>
    </div>
  )
}

export default AIAssistantStep2
